import React from "react";
import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import { COMPANY } from "../lib/constants";
import WhatsAppIcon from "./WhatsAppIcon";

export default function StickyCTAs() {
  const waLink = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(
    "Hello Melopa Invents, I would like to discuss a requirement."
  )}`;
  return (
    <>
      {/* Desktop floating */}
      <div className="hidden md:flex fixed right-4 bottom-5 z-40 flex-col gap-2 items-end">
        <a
          href={waLink}
          target="_blank"
          rel="noreferrer"
          className="btn-green shadow-elevated whitespace-nowrap"
          data-testid="sticky-whatsapp-desktop"
        >
          <WhatsAppIcon className="w-4 h-4" /> WhatsApp Now
        </a>
        <Link to="/submit" className="btn-gold shadow-elevated whitespace-nowrap" data-testid="sticky-submit-desktop">
          <FileText className="w-4 h-4" /> Submit Requirement
        </Link>
      </div>
      {/* Mobile bottom bar */}
      <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-soft p-2 grid grid-cols-2 gap-2">
        <a
          href={waLink}
          target="_blank"
          rel="noreferrer"
          className="btn-green justify-center text-sm"
          data-testid="sticky-whatsapp-mobile"
        >
          <WhatsAppIcon className="w-4 h-4" /> WhatsApp
        </a>
        <Link to="/submit" className="btn-gold justify-center text-sm" data-testid="sticky-submit-mobile">
          <FileText className="w-4 h-4" /> Submit Requirement
        </Link>
      </div>
    </>
  );
}
